import { on } from "@/lib/dom/on"
import { useTimeout } from "./use-timeout"
import { computePosition, offset as offsetCore, arrow as arrowCore, type Placement, autoUpdate, type Middleware } from "@floating-ui/dom"

type PopoverOptions = {
  triggerType: 'hover',
  arrow?: HTMLElement,
  placement: Placement,
  showDelay: number,
  offset?: number,
  hideDelay: number,
}
const defaults: PopoverOptions = {
  triggerType: 'hover',
  placement: 'top',
  showDelay: 0,
  hideDelay: 200,

}

export const popover = (triggerElement: HTMLElement, tooltipElement: HTMLElement, arrowEl?: HTMLElement, options?: PopoverOptions) => {
  const _option = Object.assign({}, defaults,
    options || {}
  )

  const { registerTimeout } = useTimeout()
  // 绑定
  const { triggerType, offset, placement, showDelay, hideDelay } = _option


  const showTooltip = () => {
    registerTimeout(() => {
      tooltipElement.style.display = 'block';
      // 使用 computePosition 定位 tooltip
      const middleware: Array<Middleware | null | undefined | false> = []
      if (offset) {
        middleware.push(offsetCore(offset))
      }
      if (arrowEl) {
        middleware.push(arrowCore({
          element: arrowEl,
        }))
      }

      computePosition(triggerElement, tooltipElement, {
        placement: placement,
        middleware: middleware,
      }).then(({ x, y, placement, middlewareData }) => {
        
        if (middlewareData.arrow && arrowEl) {
          const { x, y } = middlewareData.arrow;
          Object.assign(arrowEl.style, {
            left: x != null ? `${x}px` : '',
            top: y != null ? `${y}px` : '',
          });
        }
        tooltipElement.style.left = `${x}px`;
        tooltipElement.style.top = `${y}px`;
      });
    }, showDelay);
  }
  const hideTooltip = () => {
    registerTimeout(() => {
      tooltipElement.style.display = 'none';
    }, hideDelay);
  }

  computePosition(triggerElement!, tooltipElement, { placement: placement })

  on(triggerElement, 'mouseenter', showTooltip)
  on(triggerElement, 'mouseleave', hideTooltip)

  on(tooltipElement, 'mouseenter', showTooltip)
  on(tooltipElement, 'mouseleave', hideTooltip)
}

(window as any).popover = popover